import { Subject } from 'rxjs';
import { parsePhoneNumber } from 'awesome-phonenumber';

import MediaManager from '../../../../CommunicationClientFolder/System/ClientSide/Modules/MediaManager/mediaManager.v2.js';
import { dialTones } from './tones.js';
const COMMUNICATIONSERVER = '_FFFFFFFFFFFFFF00001606764017415688_';
const GRAPHSERVER = '_FFFFFFFFFFFFFF00001684433717737647_';

export default class CallManager {
  constructor() {
    this.config = null;
    this.lib = window.LivingScript_0070;
    this.callaManagerEvents = new Subject();
    
  }

  init(config) {
    if(this.config != null) {
     //console.log("CallManager Already Initialized");
      return;
    }
    this.config = config;
    this.mediaManager = {};
    this.activeCalls = [];
    this.smsSessions = {};

    if(window.ReactNativeWebView) {
     //console.log("Android App Started Post New");
      window.addEventListener('message', (event) => {
       //console.log("Android App Event In Bot Meesage => : ", JSON.stringify(event.data));
      });

      window.addEventListener('react_native_listener', (event) => {
       //console.log("react_native_listner Event In Bot => : ", JSON.stringify(event.detail));
        if(event.detail && event.detail.sessionId && this.smsSessions[event.detail.sessionId]) {
         //console.log("SMS Session Exec : ", JSON.stringify(this.smsSessions[event.detail.sessionId]));
          if(this.smsSessions[event.detail.sessionId].callback && typeof this.smsSessions[event.detail.sessionId].callback == 'function') {
            this.smsSessions[event.detail.sessionId].callback(null, event.detail);
          }
         //console.log("SMS Session Completed : ", JSON.stringify(this.smsSessions[event.detail.sessionId].data));
          let data = JSON.parse(JSON.stringify(this.smsSessions[event.detail.sessionId].data));
          let Client = window.botStore.getClientByID(data.ClientID);
          data.Context = JSON.parse(Client.CurrentContext);
          data.smsSessionId = window.LivingScript_0070.guid.generateSync();
          data.clientId = data.ClientID;
          data.SmsState = null;
          data.Result = event.detail;
          let params = {
            componentId : COMMUNICATIONSERVER,
            containerId : this.config.ServerID,
            command : 'SendSMSHistory',
            data : data,
            Type : 'CommApi'
          }
          window.BotServices.callComponent(params, () => {});
          delete this.smsSessions[event.detail.sessionId];
        } else if(event.detail && event.detail.originatingAddress && event.detail.phoneNumberForSendingSms) {
          let fromPhoneObj = parsePhoneNumber(event.detail.phoneNumberForSendingSms);
          let toPhoneObj = parsePhoneNumber(event.detail.originatingAddress);
          if(fromPhoneObj.valid && toPhoneObj.valid && event.detail.body) {
            let params = {
              componentId : COMMUNICATIONSERVER,
              containerId : this.config.ServerID,
              command : 'InboundSMS',
              data : {To : toPhoneObj.number.e164, From : fromPhoneObj.number.e164, Body : event.detail.body},
              Type : 'CommApi'
            }
            window.BotServices.callComponent(params, () => {});
          }
        }
      });
    } else {
     //console.log("Web App Started");
    }

    this.tones = {
      welcome : {
        id : window.LivingScript_0070.guid.generateSync(),
        soundFile : 'https://oxygencommunications.s3.us-east-1.amazonaws.com/recordings/ringtones/simpliawelcome.mp3',
        loop : false,
        timeOut : 15,
        type : 'audio'
      },
      progress : {
        id : window.LivingScript_0070.guid.generateSync(),
        soundFile : 'https://oxygencommunications.s3.us-east-1.amazonaws.com/recordings/ringtones/ringtwo.mp3',
        loop : false,
        timeOut : 15,
        type : 'audio'
      },
      hangup : {
        id : window.LivingScript_0070.guid.generateSync(),
        soundFile : 'https://oxygencommunications.s3.us-east-1.amazonaws.com/recordings/ringtones/hangup.mp3',
        loop : false,
        timeOut : 15,
        type : 'audio'
      },
      promovideo : {
        id : window.LivingScript_0070.guid.generateSync(),
        videofile : 'https://oxygencommunications.s3.amazonaws.com/recordings/ringtones/simplia+promo.mp4',
        loop : false,
        timeOut : 60,
        type : 'video'
      },
      connect : {
        id : window.LivingScript_0070.guid.generateSync(),
        soundFile : 'https://oxygencommunications.s3.amazonaws.com/recordings/ringtones/connect.mp3',
        loop : false,
        timeOut : 15,
        type : 'audio'
      }
    }
    dialTones({command : 'Register', id : this.tones.welcome.id, type : this.tones.welcome.type});
    dialTones({command : 'Register', id : this.tones.progress.id, type : this.tones.progress.type});
    dialTones({command : 'Register', id : this.tones.hangup.id, type : this.tones.hangup.type});
    dialTones({command : 'Register', id : this.tones.promovideo.id, type : this.tones.promovideo.type});
    dialTones({command : 'Register', id : this.tones.connect.id, type : this.tones.connect.type});

    const callManagerInitialized = new Event('callManagerInitialized');
    window.dispatchEvent(callManagerInitialized);
    this.deskTriggerEvents();
  }

  intClient(Client) {
   //console.log("CallManager intClient Got Event : ", Client);
    if(this.mediaManager[Client.Client] == undefined) {
      this.mediaManager[Client.Client] = new MediaManager(this.config);
      this.setupWatchOnPublishers(Client.Client);
    }
    let CurrentContext = JSON.parse(Client.CurrentContext);
    window.CommApp.registerPE(CurrentContext, this.mediaStates.bind(this), this.mediaStreams.bind(this), this.CommEvents.bind(this), (err, result) => {
     //console.log("registerPE Result : ", result);
      let currentMeetingContext = JSON.parse(Client.MeetingContext);
      if(result && result.data) {
        currentMeetingContext.serverConfig = result.data.serverConfig;
        currentMeetingContext.serverInfo = result.data.serverInfo;
       //console.log("Update updateMeetingContext ", currentMeetingContext);
        window.botStore.updateMeetingContext(Client, JSON.stringify(currentMeetingContext));
      }

      let MeetingContext = JSON.parse(JSON.stringify(currentMeetingContext));
      //let DeskContext = (Client.DeskContext) ? JSON.parse(Client.DeskContext) : {};
      MeetingContext.ClientComponentID = CurrentContext.componentId;
      MeetingContext.context = CurrentContext;
      //MeetingContext.DeskContext = DeskContext;
      
      window.CommApp.initMeeting(MeetingContext, (err, event) => {
       //console.log("Bot initMeeting Events : ", event);
        if(event) {
          this.meetingEventManager(event, CurrentContext);
          this.segmentManager(event, Client);
        }
      });

      if(CurrentContext.IsRefresh) {
       //console.log("Client Refreshed, no auto start of media");
        let callstate = {Action : 'intClient', State : false, ClientID : Client.Client};
        window.botStore.setCallState(callstate);
      } else {
        /* First Time Client Init */
        if(Client.InitialContext) {
          let InitialContext = JSON.parse(Client.InitialContext);
         //console.log("InitialContext got", InitialContext);
          if(InitialContext && InitialContext.Caller && InitialContext.Caller.Pstn) {
            let callstate = {Action : 'intClient', State : true, ClientID : Client.Client};
            window.botStore.setCallState(callstate);
            let audioParams = {
              clientId : Client.Client,
              mediaType : 'Pstn',
              context : CurrentContext,
              pstnContext : (InitialContext.PstnContext) ? InitialContext.PstnContext : {}
            }
           //console.log("AudioParams  : ", audioParams);
            this.startMedia(audioParams, () => {});
            window.BotServices.ShowClient(Client.Client);
          } else if(InitialContext && InitialContext.Caller && InitialContext.Caller.Audio) {
            let callstate = {Action : 'intClient', State : true, ClientID : Client.Client};
            window.botStore.setCallState(callstate);
            let audioParams = {
              clientId : Client.Client,
              mediaType : 'Audio',
              context : CurrentContext
            }
           //console.log("AudioParams  : ", audioParams);
            this.startMedia(audioParams, () => {});
          } else {
           //console.log("No Media to Start");
            let callstate = {Action : 'intClient', State : false, ClientID : Client.Client};
            window.botStore.setCallState(callstate);
          }
        }
      }
    });
    window.BotServices.PageState.next({Client : Client.Client, State : 'callManagerInit'});
  }

  setupWatchOnPublishers(clientId) {
   //console.log(`Setting up watch on publishers for client ${clientId}`);
    Object.keys(this.mediaManager[clientId].publishers).forEach(publisherKey => {
        const publisher = this.mediaManager[clientId].publishers[publisherKey];
        let internalJanusPub = publisher.janusPub;

        Object.defineProperty(publisher, 'janusPub', {
            get: () => internalJanusPub,
            set: (newValue) => {
               //console.log(`${publisherKey} janusPub changed from ${internalJanusPub} to ${newValue}`);
                this.callaManagerEvents.next({Name : 'PublisherState', ClientID : clientId, Data : {MediaType : publisherKey, State : (newValue ? true : false)}});
                internalJanusPub = newValue;
            },
            configurable: true
        });
    });
  }

  getPublisherStates(clientId) {
    if(this.mediaManager[clientId] && this.mediaManager[clientId].publishers) {
      let publisherStates = {};
      Object.keys(this.mediaManager[clientId].publishers).forEach(publisherKey => {
        publisherStates[publisherKey] = (this.mediaManager[clientId].publishers[publisherKey].janusPub) ? true : false;
      });
      return publisherStates;
    } else {
      return {};
    }
  }

  resetClient(Client, MeetingContext) {
    let CurrentContext = JSON.parse(Client.CurrentContext);
    window.CommApp.registerPE(CurrentContext, this.mediaStates.bind(this), this.mediaStreams.bind(this), this.CommEvents.bind(this), (err, result) => {
     //console.log("registerPE Result : ", result);
      MeetingContext.ClientComponentID = CurrentContext.componentId;
      MeetingContext.context = CurrentContext;

      if(result && result.data) {
        MeetingContext.serverConfig = result.data.serverConfig;
        MeetingContext.serverinfo = result.data.serverinfo;
      }

      window.CommApp.initMeeting(MeetingContext, (err, event) => {
       //console.log("Bot initMeeting Events : ", event);
        if(event) {
          this.meetingEventManager(event, CurrentContext);
          this.segmentManager(event, Client);
        }
      });
    });
  }

  startCall(event) {
   //console.log("CallManager startCall Got Event : ", event);
    if(event.ClientID) {
      let params = {Action : 'StartCall', State : true, ClientID : event.ClientID};
      window.botStore.setCallState(params);
      let Client = window.botStore.getClientByID(event.ClientID);
      if(Client && Client.ClientContext) {
        if(event.CallPE) {
          window.BotServices.sendAlert(event);
        }
        let CurrentContext = JSON.parse(Client.CurrentContext);
        let MeetingContext = JSON.parse(Client.MeetingContext);
        CurrentContext.MeetingContext = MeetingContext;
        let InitialContext = event.InitialContext;

        /* Check If Caller to Start an Audio Channel */
        if(InitialContext.Caller && InitialContext.Caller.Audio) {
          let audioParams = {
            clientId : event.ClientID,
            mediaType : 'Audio',
            context : CurrentContext
          }
         //console.log("AudioParams  : ", audioParams);
          this.startMedia(audioParams, () => {});
        }

        /* Check If Caller to Start a Video Channel */
        if(InitialContext.Caller && InitialContext.Caller.Video) {
          let videoParams = {
            clientId : event.ClientID,
            mediaType : 'Video',
            context : CurrentContext
          }
         //console.log("VideoParams  : ", videoParams);
          this.startMedia(videoParams, () => {});
        }

        /* Check If Caller to Start an Screen Share Channel */
        if(InitialContext.Caller && InitialContext.Caller.Screen) {
          let screenParams = {
            clientId : event.ClientID,
            mediaType : 'Screen',
            context : CurrentContext
          }
         //console.log("ScreenParams  : ", screenParams);
          this.startMedia(screenParams, () => {});
        }

        /* Check If Caller to Start an Pstn Channel */
        if(InitialContext.Caller && InitialContext.Caller.Pstn) {
          let pstnParams = {
            clientId : event.ClientID,
            mediaType : 'Pstn',
            context : CurrentContext
          }
         //console.log("PstnParams  : ", pstnParams);
          this.startMedia(pstnParams, () => {});
        }
      }
    }
  }

  endCall(event) {
   //console.log("End Call Got : ", event);
    if(event.ClientID) {
      let params = {Action : 'EndCall', State : false, ClientID : event.ClientID};
      window.botStore.setCallState(params);
      let InitialContext = event.InitialContext;
      if(InitialContext.Caller && InitialContext.Caller.Pstn) {
        let pstnParams = {
          ClientID : event.ClientID,
          MediaType : 'Pstn'
        }
       //console.log("PstnParams  : ", pstnParams);
        this.stopMedia(pstnParams, () => {});
      }
    }
  }

  endParticipant(event) {
   //console.log("End Participant Got : ", event);
    if(event.MeetingParentID) {
      let params = {
        componentId : event.MeetingParentID,
        containerId : COMMUNICATIONSERVER,
        command : 'EndParticipant',
        data : event,
        Type : 'CommApi'
      }
      window.BotServices.callComponent(params, (err, result) => {});
    }
  }

  kickOutParticipant(event) {
    if(event.MeetingParentID) {
      let params = {
        componentId : event.MeetingParentID,
        containerId : COMMUNICATIONSERVER,
        command : 'KickOut',
        data : event,
        Type : 'CommApi'
      }
      window.BotServices.callComponent(params, (err, result) => {});
    }
  }

  answerCall(event) {
    console.log("Answer Event : ", event);
    let Client = event.Client;
    if(Client) {
      let params = {Action : 'StartCall', State : true, ClientID : Client.Client};
      window.botStore.setCallState(params);
      let remoteMeetingContext = event.Event.MeetingContext;
      let InitialContext = event.Event.InitialContext;
      let localMeetingContext = JSON.parse(Client.MeetingContext);
      let CurrentContext = JSON.parse(Client.CurrentContext);
      localMeetingContext.MeetingId = remoteMeetingContext.MeetingId;
      localMeetingContext.MeetingDN = remoteMeetingContext.MeetingDN;
      localMeetingContext.MeetingRole = 'Participant';
      localMeetingContext.MeetingParentId = remoteMeetingContext.MeetingParentId;
      localMeetingContext.MeetingParentDN = remoteMeetingContext.MeetingParentDN;
      localMeetingContext.MeetingParentRole = 'Participant';
      localMeetingContext.ServerID = remoteMeetingContext.ServerID;
      localMeetingContext.ServerDN = remoteMeetingContext.ServerDN;
      CurrentContext.MeetingContext = localMeetingContext;

      window.botStore.updateMeetingContext(Client, JSON.stringify(localMeetingContext));
      let MeetingContext = JSON.parse(JSON.stringify(localMeetingContext));
      MeetingContext.ClientComponentID = Client.Client;
      MeetingContext.context = CurrentContext;

    //console.log("MeetingContext : ", MeetingContext);
      window.CommApp.initMeeting(MeetingContext, (err, event) => {
      //console.log("Bot initMeeting Events : ", event);
        if(event) {
          this.meetingEventManager(event, CurrentContext);
          this.segmentManager(event, Client);
        }
      });

      if(InitialContext && InitialContext.Caller && InitialContext.Caller.Pstn) {
        let audioParams = {
          clientId : Client.Client,
          mediaType : 'Pstn',
          context : CurrentContext,
          pstnContext : event.Event.PstnContext
        }
      //console.log("AudioParams  : ", audioParams);
        this.startMedia(audioParams, () => {});
        window.BotServices.ShowClient(Client.Client);
      } else {
        let audioParams = {
          clientId : Client.Client,
          mediaType : 'Audio',
          context : CurrentContext
        }
      //console.log("AudioParams  : ", audioParams);
        this.startMedia(audioParams, () => {});
        window.BotServices.ShowClient(Client.Client);
      }
    }
  }

  joinCall(event) {
    console.log("joinCall Event : ", event);
    let InitialContext = event.Data.InitialContext;
    let remoteMeetingContext = event.Data.MeetingContext;

    let Client = window.botStore.getClientByID(event.ClientID);

    if(Client) {
      let params = {Action : 'JoinCall', State : true, ClientID : event.ClientID};
      window.botStore.setCallState(params);
      let localMeetingContext = JSON.parse(Client.MeetingContext);
      let CurrentContext = JSON.parse(Client.CurrentContext);

      localMeetingContext.MeetingId = remoteMeetingContext.MeetingId;
      localMeetingContext.MeetingDN = remoteMeetingContext.MeetingDN;
      localMeetingContext.MeetingRole = 'Participant';
      localMeetingContext.MeetingParentId = remoteMeetingContext.MeetingParentId;
      localMeetingContext.MeetingParentDN = remoteMeetingContext.MeetingParentDN;
      localMeetingContext.MeetingParentRole = 'Participant';
      localMeetingContext.ServerID = remoteMeetingContext.ServerID;
      localMeetingContext.ServerDN = remoteMeetingContext.ServerDN;
      CurrentContext.MeetingContext = localMeetingContext;

      window.botStore.updateMeetingContext(Client, JSON.stringify(localMeetingContext));
      let MeetingContext = JSON.parse(JSON.stringify(localMeetingContext));
      MeetingContext.ClientComponentID = Client.Client;
      MeetingContext.context = CurrentContext;

     //console.log("MeetingContext : ", MeetingContext);
      window.CommApp.initMeeting(MeetingContext, (err, event) => {
       //console.log("Bot initMeeting Events : ", event);
        if(event) {
          this.meetingEventManager(event, CurrentContext);
          this.segmentManager(event, Client);
        }
      });

      if(InitialContext && InitialContext.Caller) {   
        if(InitialContext.Caller.Audio) {
          let audioParams = {
            clientId : Client.Client,
            mediaType : 'Audio',
            context : CurrentContext
          }
         //console.log("AudioParams  : ", audioParams);
          this.startMedia(audioParams, () => {});
        }

        if(InitialContext.Caller.Video) {
          let videoParams = {
            clientId : event.ClientID,
            mediaType : 'Video',
            context : CurrentContext
          }
         //console.log("VideoParams  : ", videoParams);
          this.startMedia(videoParams, () => {});
        }
      }

      if(InitialContext && InitialContext.Caller && InitialContext.Caller.Text) {   
        let termination = { 
          "MediaType" :"WebComponent",
          "Template" : "oxygen-inbox",
          "URL" : "/simplia/serverfilepath/efs/Code/github/SimpliaV2Components/inbox-wc/dist/js/app.js"
        };
        window.BotServices.openChildPanel({ClientID : event.ClientID, DisplayName : 'Inbox', Termination : termination}, ()=>{});
      }
    }
  }

  joinMeeting(event) {
   //console.log("joinMeeting Event Request : ", event);
    if(event.Data.MeetingContext) {
      this.joinCall(event);
    } else {
     //console.log("Find and join Active Meeting");
      let params = {
        componentId : COMMUNICATIONSERVER,
        containerId : this.config.ServerID,
        command : 'GetMeetings',
        data : event,
        Type : 'CommApi'
      }
      window.BotServices.callComponent(params, (err, meeting) => {
       //console.log("Get Meetings Result : ", meeting);
        if(meeting) {
          event.Data.MeetingContext = JSON.parse(meeting.MeetingContext);
          this.joinCall(event);
        }
      });
    }
  }

  joinLive(event) {
    //console.log("joinLiveMeeting Event Request : ", event);
    if(event && event.ClientID) {
      let Client = window.botStore.getClientByID(event.ClientID);
      let meetingContext = JSON.parse(Client.MeetingContext);
      let CurrentContext = JSON.parse(Client.CurrentContext);

      let callstate = {Action : 'JoinCall', State : true, ClientID : event.ClientID};
      window.botStore.setCallState(callstate);
      window.DevMgr.hideIcon(event.ClientID, 'joincall');

      let audioParams = {
        clientId : Client.Client,
        mediaType : 'Audio',
        context : CurrentContext
      }     
      this.startMedia(audioParams, () => {});

      let params = {
        componentId : COMMUNICATIONSERVER,
        containerId : this.config.ServerID,
        command : 'GetParticipants',
        data : meetingContext,
        Type : 'CommApi'
      }

      window.BotServices.callComponent(params, (err, participants) => {
          console.log("GetParticipants Result : ", participants);
          if(participants && participants.length > 0) {
            let mediaPlayer = true;
            participants.forEach((participant) => {
              if(mediaPlayer && (participant.MediaType = 'Video' || participant.MediaType == 'Screen')) {
                mediaPlayer = false;
                let config = { "Event" : { "Mode" : 'MEDIA', ClientID : event.ClientID } };
                window.DevMgr.openMediaPlayerWC(config);
              }
              if(participant.Client == event.ClientID && (participant.MediaType == 'Audio' && participant.MediaType == 'Pstn')) {
                //console.log("Skip Audio Media Start for Client : ", participant.Client);
              } else {
                participant.context = {};
                console.log("Participant connect : ", participant);
                this.mediaManager[event.ClientID].subscriberMediaStart(participant, this.subscriberEvents.bind(this), this.mediaStreamEvents.bind(this, event.ClientID), ()=>{});
              }
            });
          }
      });
    }
  }

  connectCall(event) {
   //console.log("Find and join Active Meeting : ", event);
      let params = {
        componentId : COMMUNICATIONSERVER,
        containerId : this.config.ServerID,
        command : 'GetMeetingContext',
        data : event,
        Type : 'CommApi'
      }
      window.BotServices.callComponent(params, (err, meeting) => {
       //console.log("Get Meetings Result : ", meeting);
        if(meeting) {
          event.Data.MeetingContext = JSON.parse(meeting.MeetingContext);
          this.joinCall(event);
        }
      });
  }

  getMeetingContext(event, callback) {
   //console.log("Find and join Active Meeting : ", event);
      let params = {
        componentId : COMMUNICATIONSERVER,
        containerId : this.config.ServerID,
        command : 'GetMeetingContext',
        data : event,
        Type : 'CommApi'
      }
      window.BotServices.callComponent(params, (err, meeting) => {
       //console.log("Get Meetings Result : ", meeting);
        if(meeting) {
          callback(null, JSON.parse(meeting.MeetingContext));
        } else {
          callback("No Valid Meeting Found", null);
        }
      });
  }

  previewCall(event, callback) {
   //console.log("previewCall : ", event);
    if(this.config && this.config.ServerID) {
      this.getMeetingPreview(event, callback);
    } else {
      window.addEventListener('clientManagerInitialized', (e) => {
       //console.log("CallManager was not Intialized, so waited and connected");
        this.getMeetingPreview(event, callback);
      });
    }
  }

  operatorCall(event, callback) {
   //console.log("operatorCall : ", event);
    if(this.config && this.config.ServerID) {
      this.getMeetingOperator(event, callback);
    } else {
      window.addEventListener('clientManagerInitialized', (e) => {
       //console.log("CallManager was not Intialized, so waited and connected");
        this.getMeetingOperator(event, callback);
      });
    }
  }

  getMeetingPreview(event, callback) {
    let params = {
      componentId : COMMUNICATIONSERVER,
      containerId : this.config.ServerID,
      command : 'GetMeetingPreview',
      data : event,
      Type : 'CommApi'
    }
    window.BotServices.callComponent(params, (err, frontDesks) => {
     //console.log("Get Preview frontDesks Result : ", frontDesks);
      callback(err, frontDesks);
    });
  }

  getMeetingOperator(event, callback) {
    let params = {
      componentId : COMMUNICATIONSERVER,
      containerId : this.config.ServerID,
      command : 'GetMeetingOperator',
      data : event,
      Type : 'CommApi'
    }
    window.BotServices.callComponent(params, (err, operator) => {
     //console.log("Get Operator frontDesks Result : ", operator);
      callback(err, operator);
    });
  }

  acceptCall(event) {
    console.log("acceptCall Event : ", event);
    let InitialContext = event.Event.InitialContext;
    let Client = event.Client;
    if(Client) {
      let localMeetingContext = JSON.parse(Client.MeetingContext);
      let CurrentContext = JSON.parse(Client.CurrentContext);

      if(InitialContext && InitialContext.Callee && InitialContext.Callee.Text) {
        let termination = { 
          "MediaType" :"WebComponent",
          "Template" : "oxygen-inbox",
          "URL" : "/simplia/serverfilepath/efs/Code/github/SimpliaV2Components/inbox-wc/dist/js/app.js"
        };
        window.BotServices.openChildPanel({ClientID : Client.Client, DisplayName : 'Inbox', Termination : termination}, ()=>{});
      }

      if(InitialContext && InitialContext.Callee && (InitialContext.Callee.Audio || InitialContext.Callee.Video)) {
        let audioParams = {
          clientId : Client.Client,
          mediaType : 'Audio',
          context : CurrentContext
        }

       //console.log("AudioParams  : ", audioParams);
        this.startMedia(audioParams, () => {});
      }
    }
  }

  stopCall(event) {
   //console.log("stopCall Event : ", event);
    //this.stopMedia(event, ()=>{});
    if(event.ClientID && event.ConferenceID) {
      window.CommApp.endCall(event);
      //this.stopRec({MeetingParentId : event.ConferenceID});
      //window.CommApp.endConference(event);
    }
    let index = this.activeCalls.findIndex((callInfo) => callInfo.ClientID == event.ClientID);
    if(index != -1) {
      let Client = window.botStore.getClientByID(event.ClientID);
      if(Client && Client.CurrentContext) {
        event.Context = JSON.parse(Client.CurrentContext);
        event.ActiveCalls = this.getActiveCalls(event.ClientID);
        let params = {
          componentId : COMMUNICATIONSERVER,
          containerId : this.config.ServerID,
          command : 'EndCall',
          data : event,
          Type : 'CommApi'
        }
        window.BotServices.callComponent(params, (err, result) => {});
       //console.log("StopCall Params : ", params);
      }
    }
  }

  stopPublisherMedia(event) {
    if(event.ClientID && event.MediaType) {
      let mediaParams = {
        ClientID : event.ClientID,
        MediaType : event.MediaType
      }

      this.stopMedia(mediaParams, () => {});
    }
  }

  mutePublisherMedia(event) {
    if(event.ClientID && event.MediaType) {
      let mediaParams = {
        ClientID : event.ClientID,
        MediaType : event.MediaType
      }

      this.pauseUnpauseMedia(mediaParams, () => {});
    }
  }

  unmutePublisherMedia(event) {
  }

  makeCall(data, callback) {
   //console.log("makeCall req: ", data);
    let callType = data.callType;
    let callMode = data.callMode;
    let Data = JSON.parse(JSON.stringify(data));
    if(data.ClientID) {
      let pubStates = this.getPublisherStates(data.ClientID);
      /* Make Sure One Audio Setting True */
      if(pubStates.Audio == false && pubStates.Pstn == false) {
        pubStates.Audio = true;
      }
      
     //console.log("Publisher States : ", pubStates);
      let Client = window.botStore.getClientByID(data.ClientID);
      let MeetingContext = JSON.parse(Client.MeetingContext);
     //console.log("makeCall MeetingContext : ", MeetingContext);
      if(Client && Client.CurrentContext) {
        let InitialContext = JSON.parse(Client.InitialContext);
        let LocalIP = (MeetingContext && MeetingContext.serverConfig && MeetingContext.serverConfig.LocalIP) ? MeetingContext.serverConfig.LocalIP : null;
        data.InitialContext = { 
          Caller : pubStates, 
          PstnContext : (InitialContext && InitialContext.PstnContext) ? InitialContext.PstnContext : { localip : LocalIP }
        };
        data.Context = JSON.parse(Client.CurrentContext);
        data.callSessionId = window.LivingScript_0070.guid.generateSync();
        data.clientId = data.ClientID;
        data.CallState = null;
        let params = {
          componentId : COMMUNICATIONSERVER,
          containerId : (MeetingContext && MeetingContext.ServerID) ? MeetingContext.ServerID : this.config.ServerID,
          command : 'MakeCall',
          data : data,
          Type : 'CommApi'
        }

        //console.log("makeCall Params : ", params);
        this.makeCallStates({CallSessionID : data.callSessionId, ClientID : data.ClientID, CallType : callType, CallMode : callMode, Event : 'DialCall', Data : Data}, true);
        window.BotServices.callComponent(params, (err, result) => {
          //console.log("makeCall res : ", result);
          this.callaManagerEvents.next({Name : 'MakeCall', ClientID : data.ClientID, Data : result});
          data.CallEvent = result.Event;
          switch(result.Event) {
            case 'StartCall' :
              if(result.Data && result.Data.Calltype) {
                if(result.Data.Calltype == 'INVITECALL') {
                  this.startCall({ ClientID : data.ClientID, InitialContext : { Caller : { Audio : true } } });
                }
              } else {
                this.startCall({ ClientID : data.ClientID, InitialContext : { Caller : { Audio : true } } });
              }

              this.tones.welcome.command = 'Play';
              dialTones(this.tones.welcome, (err, playState) => {
                //console.log("PlayState : ", playState, callType);
                if(playState && playState.State == 'Ended' && data.CallEvent == 'StartCall') {
                  if(callMode == 'MEETUS' || callMode == 'MESSAGEUS') {
                    window.DevMgr.videoProgressStart({});
                  } else {
                    this.tones.progress.command = 'Play';
                    this.tones.progress.loop = true;
                    dialTones(this.tones.progress, (err, playState) => {
                      //console.log("PlayState Welcome : ", playState);
                    });
                  }
                }
              });

              this.makeCallStates(result, true);
              break;
            case 'AnswerCall' :
              if(callMode == 'MEETUS') {
                window.DevMgr.videoProgressStop({});
              } else {
                this.tones.progress.loop = false;
                this.tones.progress.command = 'Pause';
                dialTones(this.tones.progress, (err, playState) => {
                  //console.log("PlayState Join : ", playState);
                });
              }
              this.makeCallStates(result, true);
              break;
            case 'JoinCall' :
              this.joinCall({ ClientID : data.ClientID, Data : result.Data});
              if(callMode == 'MESSAGEUS') {
                this.tones.progress.loop = false;
                this.tones.progress.command = 'Pause';
                dialTones(this.tones.progress, (err, playState) => {
                  //console.log("PlayState Join : ", playState);
                });
              }
              // if(callType == 'MEETING') {
              //   window.DevMgr.videoProgressStop({});
              // } else {
              //   this.tones.progress.loop = false;
              //   this.tones.progress.command = 'Pause';
              //   dialTones(this.tones.progress, (err, playState) => {
              //    //console.log("PlayState Join : ", playState);
              //   });
              // }
              this.makeCallStates(result, true);
              break;
            case 'RejectCall' :
              this.tones.progress.loop = false;
              this.tones.progress.command = 'Pause';
              dialTones(this.tones.progress, (err, playState) => {
                //console.log("PlayState Reject: ", playState);
              });
              this.makeCallStates(result, false);
              break;
            case 'ForwardCall':
              this.tones.progress.loop = false;
              this.tones.progress.command = 'Pause';
              dialTones(this.tones.progress, (err, playState) => {
                //console.log("PlayState Forward: ", playState);
              });
              this.startCall({ ClientID : data.ClientID, InitialContext : { Caller : { Pstn : true } } });
              this.makeCallStates(result, true);
              break;
            case 'ORIGINATE':
              if(result.Data && result.Data.RESULT && result.Data.RESULT.apistat == "+OK") {
                result.CallUUID = result.Data.RESULT.apires;
                this.makeCallStates(result, true);
              } else {
                this.makeCallStates(result, false);
              }
              break;
            case 'ANSWER':
              this.activeCalls.push({ClientID : data.ClientID, CallInfo : result});
              this.tones.progress.loop = false;
              this.tones.progress.command = 'Pause';
              dialTones(this.tones.progress, (err, playState) => {
                //console.log("PlayState ANSWER: ", playState);
              });
              this.makeCallStates(result, true);
              break;
            case 'HANGUP':
              this.tones.hangup.command = 'Play';
              dialTones(this.tones.hangup);
              this.makeCallStates(result, false);
              break;
            case 'InvalidNumber':
              this.makeCallStates(result, false);
              break;
            default:
              //console.log("UnHandled Event : ", result.Event);
          }
        });
      }
    }

    callback(null, {CallSessionID : data.callSessionId});
  }

  makeCallStates(event, state) {
    let index = this.activeCalls.findIndex((callInfo) => callInfo.CallSessionID == event.CallSessionID);
    if(state) {
      if(index != -1) {
        this.activeCalls[index].Data = event.Data;
        this.activeCalls[index].Event = event.Event;
        if(event.CallUUID) {
          this.activeCalls[index].CallUUID = event.CallUUID;
        }
      } else {
        this.activeCalls.push(event);
      }
    } else {
      if(index != -1) {
        this.activeCalls.splice(index, 1);
      }
    }
  }

  getActiveCalls(ClientID) {
    let activeCalls = this.activeCalls.filter((callInfo) => callInfo.ClientID == ClientID);
    return activeCalls;
  }

  getCallStates(ClientID) {
    if(this.mediaManager[ClientID]) {
      return this.mediaManager[ClientID].getPublisherStates();
    } else {
      return null;
    }
  }

  startMedia(event, callback) {
    this.mediaManager[event.clientId].publishMediaStart(event, this.publisherEvents.bind(this), this.mediaStreamEvents.bind(this, event.clientId), (event) => {
      //console.log("Publisher Status Events : ", event);
      if(event && event.Type == 'Event' && event.Event == 'Capabilities') {
        if(event.Info) {
          let mediaSetupObj = {
            Type : 'Capabilities',
            ConferenceID : event.Meeting,
            ClientComponentID : event.Client,
            Event : event
          }
          window.CommApp.mediaSetupEvents(mediaSetupObj, (err, result) => {
            //console.log("mediaSetupEvents return : ", result);
          });
        }
      }
    });
	}

  stopMedia(event, callback) {
    this.mediaManager[event.ClientID].publishMediaStop(event, callback);
    if(event.MediaType) {
      //console.log("Local Stop, don't stop subscriber");
    } else {
      this.mediaManager[event.ClientID].subscribeMediaStop();
      this.tones.hangup.command = 'Play';
      dialTones(this.tones.hangup);
    }
  }

  recordingStart(event) {
    //console.log("recordingStart Event Got : ", event);
    if(event.MeetingParentId) {
      this.recordingEventPublish(event, 'StartRec');
    }
  }

  recordingStop(event) {
    //console.log("recordingStop Event Got : ", event);
    if(event.MeetingParentId) {
      this.recordingEventPublish(event, 'StopRec');
    }
  }

  recordingEventPublish(event, command) {
    if(event.MeetingParentId) {
      let params = {
        componentId : event.MeetingParentId,
        containerId : COMMUNICATIONSERVER,
        command : command,
        data : event,
        Type : 'CommApi'
      }
      window.BotServices.callComponent(params, (err, result) => {});
    }
  }


  startRec(event) {
    let segmentInfo = window.botStore.getMediaSegments(event.MeetingParentId);
      //console.log("startRec segmentInfo : ", segmentInfo);
      if(segmentInfo.ClientId) {
        if(this.mediaManager[segmentInfo.ClientId]) {
          this.mediaManager[segmentInfo.ClientId].recordingStart(segmentInfo, (mediaEvent) => {
            //console.log("Recording Start Request Result : ", mediaEvent);
            let beginTime = new Date();
            window.botStore.addRecording({ClientId : segmentInfo.ClientId, MediaType : mediaEvent.MediaType, SegmentID : mediaEvent.SegmentID, BeginTime : beginTime.toISOString()});
          })
        } else {
          //console.log("No Call To Record!");
        }
      } else {
        //console.log("No Client Exist!");
      }
  }

  stopRec(event) {
    let segmentInfo = window.botStore.getMediaSegments(event.MeetingParentId);
      //console.log("stopRec segmentInfo : ", segmentInfo);
      if(segmentInfo.ClientId) {
        if(this.mediaManager[segmentInfo.ClientId]) {
          this.mediaManager[segmentInfo.ClientId].recordingStop(segmentInfo, (mediaEvent) => {
            //console.log("Recording Stop Request Result : ", mediaEvent);
            let recordingInfo = window.botStore.getRecording(segmentInfo.ClientId, mediaEvent.MediaType);
            let endTime = new Date();
            window.botStore.delRecording({ClientId : segmentInfo.ClientId, MediaType : mediaEvent.MediaType});
            let Client = window.botStore.getClientByID(segmentInfo.ClientId);
            if(Client && Client.CurrentContext) {
              let CurrentContext = JSON.parse(Client.CurrentContext);
             //console.log("recordingInfo Before: ", recordingInfo);
              if(recordingInfo) {
                recordingInfo.EndTime = endTime.toISOString();
                let params = {
                  componentId : COMMUNICATIONSERVER,
                  containerId : this.config.ServerID,
                  command : 'RecordingUpload',
                  data : {RecordingInfo : recordingInfo, SegmentInfo : segmentInfo, Context : CurrentContext},
                  Type : 'CommApi'
                }
                window.BotServices.callComponent(params, (err, result) => {});
              }
            }
          })
        } else {
         //console.log("No Recording To Stop!");
        }
      } else {
       //console.log("No Client Exist!");
      }
  }

  raiseHand(event) {
   //console.log("Raised Hand API GOT : ", event);
    if(event.MeetingContext && event.MeetingContext.MeetingParentId) {
      //window.CommApp.raiseHand(event);   
      let params = {
        componentId : event.MeetingContext.MeetingParentId,
        containerId : COMMUNICATIONSERVER,
        command : 'RaisedHand',
        data : event,
        Type : 'CommApi'
      }
      window.BotServices.callComponent(params, (err, result) => {});      
    }
  }

  setCapbilities(event) {
   //console.log("setCapbilities GOT : ", event);
    if(event.ClientID && event.ConferenceID) {
      window.CommApp.setCapbilities(event);
    }
  }

  getMedia(event, callback) {

  }

  sendData(event, callback) {
    this.mediaManager[event.ClientID].sendData(event);
  }

  sendDtmf(event, callback) {
    this.mediaManager[event.ClientID].sendDtmf({mediaType :'Pstn', data : event.Dtmf});
  }

  sendSMS(data, callback) {
    if(data.ClientID) {
      let Client = window.botStore.getClientByID(data.ClientID);
      if(Client && Client.CurrentContext) {
        if(window.ReactNativeWebView) {
         //console.log("Send SMS to Mobile : ", JSON.stringify(data.to.phone));
          if(data.to.phone.length > 0) {
            data.to.phone.forEach((phone) => {
             //console.log("Send SMS to Mobile : ", phone);
              let phoneObj = parsePhoneNumber(phone);
             //console.log("Send SMS to Mobile : ", JSON.stringify(phoneObj));
              if(phoneObj.valid) {
               //console.log("Send SMS to Mobile : ", phoneObj.number.significant, phoneObj.countryCode);
                let sessionId = window.LivingScript_0070.guid.generateSync();
                this.smsSessions[sessionId] = { callback : callback , data : data };
                window.ReactNativeWebView.postMessage(JSON.stringify({ 
                  method: "sms", 
                  phoneNumber : phoneObj.number.significant, 
                  countryCode : phoneObj.countryCode,
                  message : data.message,
                  clientId : data.ClientID,
                  sessionId : sessionId
                }));
              } else {
                callback("Invalid Phone Number", null);
              }
            });
          }
        } else {          
            data.Context = JSON.parse(Client.CurrentContext);
            data.smsSessionId = window.LivingScript_0070.guid.generateSync();
            data.clientId = data.ClientID;
            data.SmsState = null;
            let params = {
              componentId : COMMUNICATIONSERVER,
              containerId : this.config.ServerID,
              command : 'SendSMS',
              data : data,
              Type : 'CommApi'
            }
            window.BotServices.callComponent(params, callback);
        }
      } else {
        callback("Client Missing", null);
      }
    } else {
      callback("ClientID Missing", null);
    }
  }

  sendEmail(params, callback) {
    var urlencoded = new URLSearchParams();
    urlencoded.append("command", "sendPEEmail");
    urlencoded.append("data", JSON.stringify(params.data));
    var requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: urlencoded,
      redirect: 'follow'
    };
    
    fetch("/simplia/components/2016-08-26T19:27:07.576010ZFFF-FFFFZ", requestOptions)
      .then(response => response.text())
      .then(result => callback(null, result))
      .catch(error => callback(error, null));

  //   let request = {
  //     method : 'POST',
  //     type : "application/x-www-form-urlencoded",
  //     url : '/simplia/components/2016-08-26T19:27:07.576010ZFFF-FFFFZ',
  //     data : urlencoded.toString()
  //   };

  //   window.BotServices.httpRequest(request, (err, res) => {
  //    //console.log("SendMail Resp : ", res);
  //     callback(err, res);
  //   });
  }

  sendGraph(params, callback) {
   //console.log("sendGraph : ", params);
    if(params.clientId) {
      let Client = window.botStore.getClientByID(params.clientId);
      if(Client && Client.CurrentContext && Client.DeskContext) {
        let DeskContext = JSON.parse(Client.DeskContext);
        if(DeskContext.Node && DeskContext.Node.GraphTemplateID) {
          let graphData = {
            Context : JSON.parse(Client.CurrentContext),
            Node : DeskContext.Node,
            GraphTemplateID : DeskContext.Node.GraphTemplateID,
            GraphTemplate : DeskContext.Node.GraphTemplateID,
            Behaviour : { Role: DeskContext.Node.ArgJSON.Role, Action: DeskContext.Node.ArgJSON.Action, Result: params.channel, Cycle : 'Yes', Qualifier : params.channel, data : params.data }
          }

          let graphParams = {
            componentId : GRAPHSERVER,
            containerId : this.config.ServerID,
            command : 'ExecEdge',
            data : graphData,
            Type : 'BotApi'
          }

          window.BotServices.callComponent(graphParams, callback);
          callback(null,'Success');
        } else {
          callback(null,'Success');
        }
      } else {
        callback(null,'Success');
      }
    } else {
      callback(null,'Success');
    }
  }

  mediaStates(event) {
   //console.log("CommEvents Event ", event);
  }

  mediaStreams() {

  }

  CommStates(event, callback) {
    let params = {
      componentId : COMMUNICATIONSERVER,
      containerId : this.config.ServerID,
      command : 'CommStates',
      data : event,
      Type : 'CommApi'
    }
    window.BotServices.callComponent(params, callback);
  }

  CommEvents(event) {
   //console.log("CommEvents Event ", event);
    let openPlayerFlag = true;
    if(event.data) {
      let callstate = window.botStore.getCallState(event.ClientID);
      if(event.data.meetingInfo && event.data.meetingInfo.length > 0) {
        if(callstate && callstate.State == true) {
          let meetingInfo = event.data.meetingInfo;
          meetingInfo.forEach((meeting, i) => {
            let participant = meeting.participant;
          //console.log("participant info : ", participant);
            if(participant.MediaType == 'Video' || participant.MediaType == 'Screen') {
              if(window.DevMgr && openPlayerFlag && !window.devStore.isLanding) {
                openPlayerFlag = false;
                let params = { "Event" : { "Mode" : 'MEDIA', ClientID : event.ClientID } };
                window.DevMgr.openMediaPlayerWC(params);
              }
            }
            participant.context = {};
            this.mediaManager[event.ClientID].subscriberMediaStart(participant, this.subscriberEvents.bind(this), this.mediaStreamEvents.bind(this, event.ClientID), ()=>{});
          });
        } else {
          window.DevMgr.showIcon(event.ClientID, 'joincall');
        }
      }
    }
  }

 
  meetingEventManager(event, initailContext) {
    let localClient = window.botStore.getClientByID(initailContext.componentId);
    let context = JSON.parse(localClient.CurrentContext);
    let clientMeetingContext = JSON.parse(localClient.MeetingContext);
    context.MeetingContext = clientMeetingContext;
    
   //console.log("Got Meeting Events : ", event);
    this.callaManagerEvents.next({Name : event.command, ClientID : context.componentId, Data : event.data});
    if(event.command == 'meetingConnect') {
      let members = event.data;
      if(members && members.length > 0) {
        members.forEach((member) => {
          window.botStore.addToMeeting(member);
        });
      }
    }
    if(event.command == 'joinMeeting') {
     //console.log("Remote : ", event.data.ConferenceID, event.data.ClientComponentID, "Local : ", context.MeetingContext.MeetingId, context.componentId);
      let callstate = window.botStore.getCallState(context.componentId);
      console.log("CallState : ", callstate);
      if(event.data && event.data.ConferenceID == context.MeetingContext.MeetingId) {
        if(callstate && callstate.State == false) {
          window.DevMgr.showIcon(context.componentId, 'joincall');
        }
        if(event.data.participant.MediaType == 'Screen' || event.data.participant.MediaType == 'Video') {
          let participant = event.data.participant;
          participant.context = context;
         //console.log("Subscribe Client : ", event.data.ClientComponentID);
          if(callstate && callstate.State == true) {
            this.mediaManager[context.componentId].subscriberMediaStart(participant, this.subscriberEvents.bind(this), this.mediaStreamEvents.bind(this, context.componentId), ()=>{});
          }
        } else if(event.data.participant && event.data.ClientComponentID != context.componentId) {
          let participant = event.data.participant;
          participant.context = context;
         //console.log("Subscribe Client : ", event.data.ClientComponentID);
          if(callstate && callstate.State == true) {
            this.mediaManager[context.componentId].subscriberMediaStart(participant, this.subscriberEvents.bind(this), this.mediaStreamEvents.bind(this, context.componentId), ()=>{});
          }
        }
      }
    }

    if(event.command == 'setCapbilities') {
      if(event.data.ClientID == context.componentId) {
        if(this.mediaManager[event.data.ClientID]) {
          this.mediaManager[event.data.ClientID].setCapbilities(event.data);
        }
      }
    }

    if(event.command == 'endCall') {
     //console.log("End Call Event : ", event);
      let MeetingContext = event.data.MeetingContext;
     //console.log("Stop Media for : ", MeetingContext);      
      let Client = window.botStore.getClientByMeeting(MeetingContext.MeetingId);
      if(Client) {
        let currentMeetingContext = JSON.parse(Client.MeetingContext);
        let localMeetingContext = JSON.parse(Client.MeetingContext);
       //console.log("End Call Role : ", MeetingContext.MeetingRole, "By Client : ",  event.data.ClientID, "To Client : ", Client.Client);
        if(MeetingContext.MeetingRole == 'Moderator' || (event.data.ClientID && event.data.ClientID == Client.Client)) {
          this.stopMedia({ClientID : Client.Client}, ()=>{});
          this.callaManagerEvents.next({Name : 'EndCall', ClientID : Client.Client, MeetingContext : currentMeetingContext});
          // if(localMeetingContext.MeetingId != localMeetingContext.MeetingRootId) {
          //   localMeetingContext.MeetingId = localMeetingContext.MeetingRootId;
          //   localMeetingContext.MeetingParentId = localMeetingContext.MeetingRootId;
          //   localMeetingContext.MeetingRole = 'Moderator';
          //   localMeetingContext.MeetingParentRole = 'Moderator';
          //  //console.log("End Call localMeetingContext : ", localMeetingContext);
          //   window.botStore.updateMeetingContext(Client, JSON.stringify(localMeetingContext));
          //   window.CommApp.cleanMeeting(MeetingContext, (err, result) => {
          //    //console.log("cleanMeeting res : ", result, err);
          //   });
          //   this.resetClient(Client, localMeetingContext);
          // }
        }
      }
    }

    if(event.command == 'StartRec') {
      this.startRec(event.data);
    }

    if(event.command == 'StopRec') {
      this.stopRec(event.data);
    }

    if(event.command == "meetingMediaStates") {
      if(event.data && event.data.MediaEvent) {
        let mediaEvent = event.data.MediaEvent;
        if(mediaEvent && event.data.Type == "Subscriber") {
         //console.log("Subscriber Media State Event : ", mediaEvent);
          if(mediaEvent.State) {
           //console.log("Subscriber State is up");
          } else {
           //console.log("Need to clean this subscriber handler : ", mediaEvent);
            let Client = window.botStore.getClientByMeeting(mediaEvent.Meeting);
            if(Client) {
              this.mediaManager[Client.Client].cleanSubsciber(mediaEvent);
              //this.mediaManager[Client.Client].subscribeMediaStop();
            }
          }
        }
      }
    }

    if(event.command == 'EndParticipant') {
      let Client = window.botStore.getClientByMeeting(event.data.MeetingParentID);
     //console.log("EndParticipant got Client : ", Client);  
      if(Client && Client.Client == event.data.ClientID) {
        let currentMeetingContext = JSON.parse(Client.MeetingContext);
        let localMeetingContext = JSON.parse(Client.MeetingContext);
        this.stopMedia({ClientID : Client.Client}, ()=>{});
        this.callaManagerEvents.next({Name : 'EndCall', ClientID : Client.Client, MeetingContext : currentMeetingContext});
        // if(localMeetingContext.MeetingId != localMeetingContext.MeetingRootId) {
        //   localMeetingContext.MeetingId = localMeetingContext.MeetingRootId;
        //   localMeetingContext.MeetingParentId = localMeetingContext.MeetingRootId;
        //   localMeetingContext.MeetingRole = 'Moderator';
        //   localMeetingContext.MeetingParentRole = 'Moderator';
        //  //console.log("End Call localMeetingContext : ", localMeetingContext);
        //   window.botStore.updateMeetingContext(Client, JSON.stringify(localMeetingContext));
        //   window.CommApp.cleanMeeting(MeetingContext, (err, result) => {
        //    //console.log("cleanMeeting res : ", result, err);
        //   });
        //   this.resetClient(Client, localMeetingContext);
        // }
      }
    }

    if(event.command == 'EndClient') {
      let Client = window.botStore.getClientByMeeting(event.data.MeetingParentID);
      if(Client) {
       //console.log("Send event to notify closed client");
        this.callaManagerEvents.next({Name : 'EndClient', ClientID : Client.Client, Data : event.data});
        if(event.data.MediaEvent) {
          let mediaEvent = event.data.MediaEvent;
          this.mediaManager[Client.Client].cleanSubsciber(mediaEvent);
        }
      }
    }

    if(event.command == 'RaisedHand') {
     //console.log("Got Raised Hand Event : ", event);
      if(event.data && event.data.MeetingContext) {
        let Client = window.botStore.getClientByMeeting(event.data.MeetingContext.MeetingParentId);
        if(Client) {
          this.callaManagerEvents.next({Name : 'RaisedHand', ClientID : Client.Client, Data : event.data});
        }
      }
    }
  }

  publisherEvents(event) {
   //console.log("publisherEvents => ", event);
    if(event && event.Client) {
      let Client = window.botStore.getClientByID(event.Client);
      let ClientContext = JSON.parse(Client.ClientContext);

      let mediaEventObj = {
        Type : 'Publisher',
        ConferenceID : event.Meeting,
        ClientComponentID : event.Client,
        MediaEvent : event
      }
      window.CommApp.mediaStateEvents(mediaEventObj, (err, result) => {
       //console.log("mediaStateEvents return : ", result);
      });

      if(event.State) {
        let commandData = {
            EnvelopeType : 'All',
            ConferenceID : event.Meeting,
            ClientComponentID : event.Client,
            BrowserTabID : Client.BrowserTab,
            MediaTemplate : '_FFFFFFFFFFFFFF00001565355394363351_',
            MediaFeedID : event.MediaFeedID,
            RemoteFeedID : event.RemoteFeedID,
            GrantPE : ClientContext.GrantPE,
            MediaType : event.MediaType,
            MediaServerChannel : event.MediaServerChannel,
            FreeSwitchServer : event.FreeSwitchServer,
            Capabilities : JSON.stringify(event.Capabilities),
            grantItem : ClientContext,
            webrtcEvent : event,
            historyData : null
        };

        window.CommApp.joinMeeting(commandData, (err, result) => {
         //console.log("joinMeeting return : ", result);
        });

        //this.startRec({MeetingParentId : event.Meeting});
      }
    }
  }

  subscriberEvents(event) {
   //console.log("subscriberEvents : ", event);
    let mediaEventObj = {
      Type : 'Subscriber',
      ConferenceID : event.Meeting,
      ClientComponentID : event.Client,
      MediaEvent : event
    }
    window.CommApp.mediaStateEvents(mediaEventObj, (err, result) => {
     //console.log("mediaStateEvents return : ", result);
    });

    if(event.State == false) {
      window.botStore.delStream({
        MeetingId : event.Meeting,
        ClientId : event.Client,
        MediaType : event.MediaType
      });
    }
  }

  mediaStreamEvents(localClient, stream, mediaType, grantId, clientId, meetingId, attempts, capabilities) {
   //console.log("mediaStreams Event ", localClient, mediaType, clientId, meetingId, attempts, capabilities);
    if(mediaType == 'Audio') {
      window.CommApp.mediaStreamEvents({ Stream : stream, MediaType : mediaType, GrantID : grantId, PanelID : clientId} , () => {});
      if(attempts == 0) {        
        let activeCall = this.getActiveCalls(localClient);
       //console.log("Active Calls : ", activeCall, localClient);
        if(activeCall && activeCall[0] && activeCall[0].CallMode == 'MEETUS') {
            window.DevMgr.videoProgressStop({});

            this.tones.connect.command = 'Play';
            this.tones.progress.loop = false;
            dialTones(this.tones.connect, () => {});
            
            let params = { "Event" : { "Mode" : 'MEDIA', ClientID : localClient } };
            window.DevMgr.openMediaPlayerWC(params);
          } else {
            this.tones.progress.loop = false;
            this.tones.progress.command = 'Pause';
            dialTones(this.tones.progress, (err, playState) => {
             //console.log("PlayState Join : ", playState);
            });

            this.tones.connect.command = 'Play';
            this.tones.progress.loop = false;
            dialTones(this.tones.connect, () => {});
          }
      }
      window.botStore.addStream({
        MeetingId : meetingId,
        ClientId : clientId,
        MediaType : mediaType,
        Stream : stream,
        capabilities : capabilities,
        Width : 300,
        Height : 300,
        Position : { x : 0, y : 0 },
        Src : null,
        Type : null
      });
    } else if(mediaType == 'Pstn') {
      window.CommApp.mediaStreamEvents({ Stream : stream, MediaType : mediaType, GrantID : grantId, PanelID : clientId} , () => {});
    } else if(mediaType == 'Data') {
      //this.vueApp.updateData(stream);
    } else if(mediaType == 'Screen' || mediaType == 'Video') {
      window.botStore.addStream({
        MeetingId : meetingId,
        ClientId : clientId,
        MediaType : mediaType,
        Stream : stream,
        capabilities : capabilities,
        Width : 300,
        Height : 300,
        Position : { x : 0, y : 0 },
        Src : null,
        Type : null
      });
    }
  }

  segmentManager(event, Client) {
    if(event.command == 'initSegment') {
      event.data.ClientId = Client.Client;
      window.botStore.setMediaSegments(event.data);
    }
  }

  pauseCall(event) {
   //console.log("Pause Call Got : ", event);
  }

  unPauseCall(event) {
   //console.log("UnPause Call Got : ", event);
  }

  muteCall(event) {
   //console.log("Mute Call Got : ", event);
    mutePublisher();
  }

  unMuteCall(event) {
   //console.log("Unmute Call Got : ", event);
  }

  muteMedia(event) {
   //console.log("Mute Media Got : ", event);
    this.mediaManager[event.ClientID].mutePublisher(event, (result) => {
     //console.log("Mute Media Result : ", result);
      if(result && result.Data && result.Data.configured && result.Data.configured == 'ok') {
        this.callaManagerEvents.next({Name : 'PublisherState', ClientID : event.ClientID, Data : {MediaType : 'Audio', Muted : true}});
      }      
    });
  }

  unmuteMedia(event) {
   //console.log("Unmute Media Got : ", event);
    this.mediaManager[event.ClientID].unmutePublisher(event, (result) => {
     //console.log("Unmute Media Result : ", result);
      this.callaManagerEvents.next({Name : 'PublisherState', ClientID : event.ClientID, Data : {MediaType : 'Audio', Muted : false}});
    });
  }

  deskTriggerEvents() {
    window.BotServices.Events.subscribe({
      next : ((event) => {
          if(event.Triggers && event.Triggers.Type == "DeskTrigger" && event.Triggers.Data && event.Triggers.Data.Client) {
            console.log("DeskTrigger Event In CallManager : ", event);
            let params = {
              componentId : COMMUNICATIONSERVER,
              containerId : this.config.ServerID,
              command : 'SetDeskInfo',
              data : event.Triggers.Data,
              Type : 'CommApi'
            }
            window.BotServices.callComponent(params, () => {});
          }
      }),
    });
  }

  addLiveContact(event) {
    this.callaManagerEvents.next({Name : 'addLiveContact', ClientID : event.ClientID, Data : event});
  }
}

function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}
